module.exports = __webpack_public_path__ + "media/webfonts/fa-brands-400-98f20b9e.eot";